import { render, staticRenderFns } from "./SpendingTree.vue?vue&type=template&id=7b606e52"
import script from "./SpendingTree.vue?vue&type=script&lang=js"
export * from "./SpendingTree.vue?vue&type=script&lang=js"
import style0 from "./SpendingTree.vue?vue&type=style&index=0&id=7b606e52&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports